<flex-row class="notificationBar {{ level }}">
  <div>
    <app-icon [name]="level" [color]="'var(--jet-black)'" class="icon" style="width: 20px"></app-icon>
  </div>
  <div style="padding-left: 10px"><ng-content></ng-content></div>
</flex-row>
